export class Company {
  id: string = '';
  name: string = '';
  address: string = '';
  email: string = '';
  phone1: string = '';
  socialLinks = {
    facebook: '',
    linkedin: '',
    twitter: '',
    google: '',
  };
  active: boolean = false;
  createdAt: Date = new Date();
  updatedAt: Date = new Date();

  selected: boolean = false;

  constructor() { };

  fromJson(data): Company {
    let company = data;
    company.createdAt = new Date(data.createdAt);
    company.updatedAt = new Date(data.updatedAt);

    return company;
  }
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/company/company.model.ts
 **/